export default "__VITE_ASSET__j1X1ql2o__"